"use strict";
export var SwapStatus = /* @__PURE__ */ ((SwapStatus2) => {
  SwapStatus2["PENDING"] = "PENDING";
  SwapStatus2["SUCCESS"] = "SUCCESS";
  SwapStatus2["NOT_FOUND"] = "NOT_FOUND";
  SwapStatus2["FAILED"] = "FAILED";
  SwapStatus2["EXPIRED"] = "EXPIRED";
  return SwapStatus2;
})(SwapStatus || {});
